module.exports = __webpack_public_path__ + "img/header-tips.70970c91.png";